/**
 *
 * @param {String} querySelectorOrObject string selector of the element to wait or object for config
 * @param {Number} timeOutInMilliseconds how much time do you want to wait for the element
 * @param {Number} sleepInMillis frecuency to validate if the element exist already
 * @param {funcion} callBack function you want to run when the element is finded
 */
export default function waitForElement(
  querySelectorOrObject,
  ...args
) {
  let querySelector, timeOutInMilliseconds, sleepInMillis, callBack;

  if (typeof querySelectorOrObject === 'object') {
    ({querySelector, timeOutInMilliseconds, sleepInMillis, callBack} = querySelectorOrObject);
  } else {
    querySelector = querySelectorOrObject;
    [timeOutInMilliseconds, sleepInMillis, callBack] = args;
  }
  const t0 = performance.now();
  const myInterval = setInterval(detectElements, sleepInMillis);
  /**
   * Function to detect an element, based in the input
   */
  function detectElements() {
    const t1 = performance.now();
    if ((t1 - t0) <= timeOutInMilliseconds) {
      const elements = document.querySelectorAll(querySelector);
      if (elements.length > 0) {
        clearInterval(myInterval);
        callBack(elements);
      }
    } else {
      clearInterval(myInterval);
    }
  }
}
